<template>
    <div
        class="widget"
        :class="{
            'widget--page': props.page,
            'widget--space': props.space,
            'widget--primary': props.primary,
            'widget--secondary': props.secondary,
        }"
    >
        <slot></slot>
    </div>
</template>
<script setup lang="ts">
// Other
import { defineProps } from 'vue';

const props = defineProps({
    page: { type: Boolean, default: false },
    space: { type: Boolean, default: false },
    primary: { type: Boolean, default: false },
    secondary: { type: Boolean, default: false },
});
</script>
<style lang="scss">
.widget {
    &--page {
        margin: 0 0.375rem;

        @media (min-width: #{$breakpoint-tablet + 1}) {
            margin: 0 1rem;
        }
    }

    &--space {
        margin-bottom: 1.875rem;
    }

    &--primary {
        padding: 1rem;
        border-radius: 1.5rem;
        border-left: 0.0625rem solid var(--background-tertiary);
        background: var(--background-color);
        --background-color: var(--background-primary);
        box-shadow: 0 0 0.6875rem 0 rgba(0, 0, 0, 0.04);
    }

    &--secondary {
        padding: 1rem;
    }
}
</style>
